
import Vue from 'vue';
import { ImageLockRatio } from '../ImageLockRatio';

export default Vue.extend({
  components: { ImageLockRatio },
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: () => '',
    },
    flag: {
      type: String,
      required: false,
    },
    fallbackImage: {
      type: String,
      required: false,
    },
    fallbackFlag: {
      type: String,
      required: false,
    },
  },
});
